//
// # Circuit Namespace
//

export { extractCircuit } from "./extractor";
